import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { EscrowProvider } from './contexts/EscrowContext';
import AdminPage from './components/AdminPage';
import './styles/themes.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <WalletProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<EscrowProvider><AdminPage /></EscrowProvider>} />
              <Route path="/manage" element={<EscrowProvider><AdminPage /></EscrowProvider>} />
            </Routes>
          </div>
        </Router>
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App;